import { Stack } from '@mui/material'
import { queryClient } from '@common/config/api/queryClient'
import { SPACING } from '@common/theme/spacing'
import SubjectsTimepointsTable from '@features/subject/components/SubjectsTimepointsTable/SubjectsTimepointsTable'
import useStudySubjectsTimepointsTableHandlers from '../hooks/useStudySubjectsTimepointsTableHandlers'
import CreateStudySubjectDialog from '@features/study_details/Subjects/components/CreateStudySubjectDialog'
import { useGetSubjectsList } from '../hooks/useGetSubjectsList'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { SitePermission } from '@auth/permissionsEnum'

export default function SubjectsTimepoints() {
  const {
    page,
    subjectsTimepointsParams,
    handleSearch,
    handleAddClick,
    handlePageChange,
    handleRowsPerPageChange,
    handleRequestSort,
    handleSubmittedOnlyChange,
    isSubjectDialogVisible,
    setIsSubjectDialogVisible,
  } = useStudySubjectsTimepointsTableHandlers()

  const { globalPermissions, studyPermissions } = useCombinedPermissions()
  const submittedOnlyLocked = [globalPermissions, studyPermissions].some((permissions) =>
    permissions.includes(SitePermission.VIEW_SUBMITTED_VISITS_ONLY),
  )
  const submittedOnly = submittedOnlyLocked || Boolean(subjectsTimepointsParams.submitted_only)
  const listParams = {
    ...subjectsTimepointsParams,
    submitted_only: submittedOnly || undefined,
  }

  const { data: subjectsList } = useGetSubjectsList(['SubjectsList'], listParams)

  return (
    <>
      <Stack spacing={SPACING.sectionsSpacing}>
        <SubjectsTimepointsTable
          onSearch={handleSearch}
          onAddClick={handleAddClick}
          searchValue={subjectsTimepointsParams.search ?? ''}
          page={page}
          subjectsTimepointsParams={listParams}
          onPageChange={(event, newPage) => handlePageChange(subjectsList?.data, event, newPage)}
          onRowsPerPageChange={handleRowsPerPageChange}
          onRequestSort={handleRequestSort}
          submittedOnly={submittedOnly}
          submittedOnlyLocked={submittedOnlyLocked}
          onSubmittedOnlyChange={handleSubmittedOnlyChange}
        />
      </Stack>
      {isSubjectDialogVisible ? (
        <CreateStudySubjectDialog
          onClose={(data) => {
            setIsSubjectDialogVisible(false)
            if (data) {
              queryClient.invalidateQueries({ queryKey: ['SubjectsList'] })
            }
          }}
        />
      ) : null}
    </>
  )
}
